import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import { styles } from '../../styles/styles';
import { ActivityFeedSearch } from './components/activity-feed-search';
import { ActivityFeedFilter } from './components/activity-feed-filter';
import { ActivityFeedClose } from './components/activity-feed-close';

interface IProps {
  onSetSearchQuery: (query: string) => void;
  onClose?: () => void;
  resetFilters?: () => void;
}

const ActivityFeedHeader: FC<IProps> = ({
  onSetSearchQuery,
  onClose,
  resetFilters,
}) => {
  const [showSearch, setShowSearch] = useState(false);

  const onSearchOpen = () => setShowSearch(true);

  const onSearchClose = () => {
    setShowSearch(false);
    onSetSearchQuery('');
  };

  const handleClose = () => {
    onClose?.();
    resetFilters?.();
  };

  return (
    <Grid sx={styles.header}>
      <Grid sx={styles.searchAndFilterContainer}>
        <ActivityFeedSearch
          showSearch={showSearch}
          onSearchClose={onSearchClose}
          onSearchOpen={onSearchOpen}
          onSetSearchQuery={onSetSearchQuery}
        />
        <ActivityFeedFilter />
      </Grid>

      {onClose && <ActivityFeedClose onClose={handleClose} />}
    </Grid>
  );
};

export default ActivityFeedHeader;
